<template>
    <div class="row">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <h3 class="panel-title">Event Jobs</h3>
            </div>
            <table class="table table-bordered table-striped table-condensed">
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>Job</th>
                        <th class="text-center">Allow Signup</th>
                        <th class="text-center">Specify Times</th>
                        <th class="text-center">Email Reminders</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(eventJob, index) in eventJobs">
                        <td class="row-actions row-actions-2-btn">
                            <button @click="editJob(eventJob)" class="btn btn-sm btn-primary"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button>
                            <button @click="removeJob(eventJob.id)" class="btn btn-sm btn-danger"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span></button>
                        </td>
                        <td><span class="h3">{{ eventJob.job_name }}</span><br />{{ eventJob.description }}</td>
                        <td class="text-center">
                            <span class="glyphicon glyphicon-ok text-success" v-if="eventJob.allow_signup" aria-hidden="true"></span>
                            <span class="glyphicon glyphicon-remove text-danger" v-if="!eventJob.allow_signup" aria-hidden="true"></span>
                        </td>
                        <td class="text-center">
                            <span class="glyphicon glyphicon-ok text-success" v-if="eventJob.specify_job_times" aria-hidden="true"></span>
                            <span class="glyphicon glyphicon-remove text-danger" v-if="!eventJob.specify_job_times" aria-hidden="true"></span>
                        <td class="text-center">
                            <span class="glyphicon glyphicon-ok text-success" v-if="eventJob.email_reminders" aria-hidden="true"></span>
                            <span class="glyphicon glyphicon-remove text-danger" v-if="!eventJob.email_reminders" aria-hidden="true"></span>
                        <td>
                            <v-event-job-timeslots-embedded :event-id="eventId" :job-id="eventJob.id"></v-event-job-timeslots-embedded>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


</template>
<script>
    export default {
        props: [
            'eventId'
        ],

        data: function () {
            return {
                eventJobs: []
            }
        },

        mounted() {
            this.getEventJobs();
        },

        methods: {
            getEventJobs() {
                axios.get(`/api/v1/club_events/${this.eventId}/jobs`).then((response) => {
                    this.eventJobs = response.data;
                }).catch((error) => {
                    this.$message({message: 'There was a problem loading event jobs.', type: 'error'});
                });
            },

            formatDate(theDate) {
                return moment(theDate).format("DD/MM/YYYY")
            },

            removeJob(id) {
                axios.delete(`/api/v1/club_events/${this.eventId}/jobs/${id}`)
                    .then(response => {
                        this.getEventJobs();
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem removing the job.', type: 'error'});
                    });
            },

            editJob(event) {
                this.$emit('job-edit', event);
            }
        },
    }
</script>
